var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrationTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flat"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 31,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 31,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 31,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 31,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 14,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 22,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 48,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 40,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-8.276 19.979) rotate(-45)",
    width: 2,
    x: 18.98,
    y: 18.98
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-10.619 25.636) rotate(-45)",
    width: 2,
    x: 24.636,
    y: 24.636
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-18.234 44.021) rotate(-45)",
    width: 2,
    x: 43.021,
    y: 43.021
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-15.891 38.364) rotate(-45)",
    width: 2,
    x: 37.364,
    y: 37.364
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-25.275 27.021) rotate(-45)",
    width: 2,
    x: 18.98,
    y: 43.021
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-19.619 29.364) rotate(-45)",
    width: 2,
    x: 24.636,
    y: 37.364
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 31,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 31,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 18,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 44,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-9.447 22.808) rotate(-45)",
    width: 2,
    x: 21.808,
    y: 21.808
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-17.062 41.192) rotate(-45)",
    width: 2,
    x: 40.192,
    y: 40.192
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-22.447 28.192) rotate(-45)",
    width: 2,
    x: 21.808,
    y: 40.192
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-4.062 35.808) rotate(-45)",
    width: 2,
    x: 40.192,
    y: 21.808
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-1.234 36.979) rotate(-45)",
    width: 2,
    x: 43.021,
    y: 18.98
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 31,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5,
    style: {
      fill: "#818589"
    },
    width: 2,
    x: 31,
    y: 52
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 5,
    x: 7,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    width: 5,
    x: 52,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.999,
    style: {
      fill: "#818589"
    },
    transform: "translate(-6.665 16.09) rotate(-45)",
    width: 2,
    x: 15.09,
    y: 13.59
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.999,
    style: {
      fill: "#818589"
    },
    transform: "translate(-19.845 47.91) rotate(-45)",
    width: 2,
    x: 46.91,
    y: 45.41
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-29.165 25.41) rotate(-45)",
    width: 4.999,
    x: 13.59,
    y: 46.91
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(2.655 38.59) rotate(-45)",
    width: 4.999,
    x: 45.41,
    y: 15.09
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-6.891 34.636) rotate(-45)",
    width: 2,
    x: 37.364,
    y: 24.636
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-12.632 10.469) rotate(-22.508)",
    width: 2,
    x: 18.989,
    y: 35.975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.522,39.652a2,2,0,1,0-1.082,2.615A2,2,0,0,0,13.522,39.652Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-6.993 18.906) rotate(-22.508)",
    width: 2,
    x: 43.011,
    y: 26.025
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.478,24.348a2,2,0,0,0,2.613,1.081,2,2,0,1,0-2.613-1.081Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-5.594 11.868) rotate(-22.508)",
    width: 2,
    x: 26.025,
    y: 18.989
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.584,13.674a2,2,0,1,0-1.851-1.234A2,2,0,0,0,23.584,13.674Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-14.031 17.507) rotate(-22.508)",
    width: 2,
    x: 35.975,
    y: 43.011
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.652,50.478a2,2,0,1,0,2.615,2.613,1.983,1.983,0,0,0,0-1.531A2.006,2.006,0,0,0,39.652,50.478Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-23.979 52.13) rotate(-67.492)",
    width: 2,
    x: 26.025,
    y: 43.011
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.346,50.478a2,2,0,0,0-2.613,1.082,2,2,0,0,0,1.082,2.613,2,2,0,0,0,1.533,0,1.981,1.981,0,0,0,1.081-1.082A2,2,0,0,0,24.346,50.478Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(4.354 46.495) rotate(-67.492)",
    width: 2,
    x: 35.975,
    y: 18.989
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.654,13.522a1.975,1.975,0,0,0,.762.153,2.005,2.005,0,0,0,1.851-1.235,2,2,0,1,0-3.7-1.531A2,2,0,0,0,39.654,13.522Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-12.63 35.146) rotate(-67.492)",
    width: 2,
    x: 18.989,
    y: 26.025
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.909,25.429a2,2,0,1,0-1.082-1.081A1.992,1.992,0,0,0,10.909,25.429Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-6.995 63.479) rotate(-67.492)",
    width: 2,
    x: 43.011,
    y: 35.975
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-11.764 11.767) rotate(-22.508)",
    width: 2.001,
    x: 22.685,
    y: 34.444
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-7.861 17.608) rotate(-22.508)",
    width: 2.001,
    x: 39.314,
    y: 27.556
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.001,
    style: {
      fill: "#818589"
    },
    transform: "translate(-6.892 12.736) rotate(-22.508)",
    width: 2,
    x: 27.556,
    y: 22.685
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.001,
    style: {
      fill: "#818589"
    },
    transform: "translate(-12.733 16.639) rotate(-22.508)",
    width: 2,
    x: 34.444,
    y: 39.314
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-19.62 51.262) rotate(-67.492)",
    width: 2.001,
    x: 27.555,
    y: 39.315
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-0.005 47.363) rotate(-67.492)",
    width: 2.001,
    x: 34.444,
    y: 22.685
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.001,
    style: {
      fill: "#818589"
    },
    transform: "translate(-11.762 39.505) rotate(-67.492)",
    width: 2,
    x: 22.685,
    y: 27.555
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.001,
    style: {
      fill: "#818589"
    },
    transform: "translate(-7.858 59.129) rotate(-67.503)",
    width: 2,
    x: 39.315,
    y: 34.444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.091,38.571a2,2,0,1,0,1.082,1.081A1.981,1.981,0,0,0,53.091,38.571Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-13.499 9.171) rotate(-22.508)",
    width: 2,
    x: 15.294,
    y: 37.506
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-6.126 20.204) rotate(-22.508)",
    width: 2,
    x: 46.706,
    y: 24.494
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-4.296 11.001) rotate(-22.508)",
    width: 2,
    x: 24.494,
    y: 15.294
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-15.329 18.374) rotate(-22.508)",
    width: 2,
    x: 37.506,
    y: 46.706
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-28.337 52.996) rotate(-67.492)",
    width: 2,
    x: 24.494,
    y: 46.706
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(8.713 45.629) rotate(-67.492)",
    width: 2,
    x: 37.506,
    y: 15.294
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-13.496 30.787) rotate(-67.492)",
    width: 2,
    x: 15.294,
    y: 24.494
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#818589"
    },
    transform: "translate(-6.129 67.837) rotate(-67.492)",
    width: 2,
    x: 46.706,
    y: 37.506
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.285,34.7l2.25,2.25,1.414-1.414-2.25-2.25A2.746,2.746,0,0,0,34.816,33H38V31H34.816a2.746,2.746,0,0,0-.117-.285l2.25-2.25-1.414-1.414-2.25,2.25A2.746,2.746,0,0,0,33,29.184V26H31v3.184a2.746,2.746,0,0,0-.285.117l-2.25-2.25-1.414,1.414,2.25,2.25a2.746,2.746,0,0,0-.117.285H26v2h3.184a2.746,2.746,0,0,0,.117.285l-2.25,2.25,1.414,1.414,2.25-2.25a2.746,2.746,0,0,0,.285.117V38h2V34.816A2.746,2.746,0,0,0,33.285,34.7ZM33,32a1,1,0,1,1-1-1A1,1,0,0,1,33,32Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,2a3,3,0,1,0,3,3A3,3,0,0,0,32,2Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,32,6Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,56a3,3,0,1,0,3,3A3,3,0,0,0,32,56Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,32,60Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,29a3,3,0,1,0,3,3A3,3,0,0,0,5,29Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,5,33Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,29a3,3,0,1,0,3,3A3,3,0,0,0,59,29Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,59,33Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.787,10.787a3,3,0,1,0,4.242,0A3,3,0,0,0,10.787,10.787Zm2.828,2.828a1,1,0,1,1,0-1.414A1,1,0,0,1,13.615,13.615Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.971,48.971a3,3,0,1,0,4.242,0A3,3,0,0,0,48.971,48.971ZM51.8,51.8a1,1,0,1,1,0-1.414A1,1,0,0,1,51.8,51.8Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.787,48.971a3,3,0,1,0,4.242,0A3,3,0,0,0,10.787,48.971ZM13.615,51.8a1,1,0,1,1,0-1.414A1,1,0,0,1,13.615,51.8Z",
    style: {
      fill: "#818589"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.971,10.787a3,3,0,1,0,4.242,0A3,3,0,0,0,48.971,10.787ZM51.8,13.615a1,1,0,1,1,0-1.414A1,1,0,0,1,51.8,13.615Z",
    style: {
      fill: "#818589"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationTwo);
export default __webpack_public_path__ + "static/media/celebration-two.51e78e14d72a933722e3f790fc2c4b82.svg";
export { ForwardRef as ReactComponent };